import React from 'react';
import { useDispatch } from 'react-redux';
import { microsoft_login_action } from '../_redux/action';

const MicrosoftLogin = ({ title }) => {
  const dispatch = useDispatch();

  const handleLogin = async () => {
    await dispatch(microsoft_login_action());
  };

  return (
    <div className="flex items-center justify-center my-2">
      <button
        onClick={() => handleLogin()}
        className="w-full p-5 mb-5 text-sm font-bold leading-none text-white transition duration-300 rounded-lg hover:bg-blue-700 bg-blue-900"
      >
        {title || 'Login with Microsoft'}
      </button>
    </div>
  );
};

export default MicrosoftLogin;
